import styled, { css } from 'styled-components'

import theme, { rem } from '../../utils/theme'

const StyledButton = styled.button`
  font-size: ${theme.typography.fontSizeTinyish};
  font-weight: ${theme.typography.fontWeightBold};
  color: var(--custom-primary-color, ${theme.palette.primary.main});
  text-decoration: underline;
  margin: 0 0 0.5rem 0;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
`

const StyledEntryModeSelect = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin: ${rem(10)} 0 0;

  ${props =>
    props.groupAddressFields &&
    css`
      justify-content: flex-end;
      margin: 0;

      ${StyledButton} {
        margin: ${rem(-18)} 0 0;
      }
    `}
`

function EntryModeSelect(props) {
  const { entryMode, setEntryMode, groupAddressFields, id, disabled } = props

  const handleSwitchEntryMode = () => {
    if (!disabled) {
      setEntryMode(entryMode === 'search' ? 'manual' : 'search')
    }
  }

  const buttonLabel = entryMode === 'search' ? 'Enter address manually' : 'Search address'

  return (
    <StyledEntryModeSelect groupAddressFields={groupAddressFields}>
      <StyledButton id={`${id}-mode-trigger`} disabled={disabled} onClick={handleSwitchEntryMode}>
        {buttonLabel}
      </StyledButton>
    </StyledEntryModeSelect>
  )
}

export default EntryModeSelect
